import React from 'react';
import get from 'lodash/get';
import noop from 'lodash/noop';
import { HostContext } from './provider';

export const trackingApplication = {
  COLLEGE_PROFILE: 'college_profile',
};

export const trackingLocations = {
  ABOUT_US: 'college_profile_summary', // tracked for each overview tab load
  APPLY_ONLINE: 'college_profile_header',
  COMPARE_ME: 'compare_me',
  COLLEGE_PROFILE_HEADER: 'college_profile_header', // for WebTour tracked for each overview tab load
  COLLEGE_PROFILE_REFERRER: 'college_profile_referrer',
  DEGREE_OFFERINGS: 'degree_offerings',
  FAVORITE: 'favorite',
  HUBPAGE: 'hubpage',
  LEARN_MORE: 'learn_more_drop_down',
  MAJORS_SEARCH: 'majors_search',
  MASTHEAD_URL: 'masthead_url',
  PROFILES: 'college_profile_profiles_tab',
  REQUEST_INFO: 'college_profile_communicate_drop_down',
  TABS: {
    ADMISSIONS: 'admissions',
    COSTS: 'costs',
    CURRENT_TAB: 'GET_CURRENT_TAB',
    OVERVIEW: 'overview',
    PROFILES: 'profiles',
    STUDENT_LIFE: 'studentLife',
    STUDIES: 'studies',
    TABS: 'tabs',
  },
  UNFAVORITE: 'unfavorite',
  VISITS_CANCEL: 'visits_cancel',
  VISITS_REGISTER: 'visits_register',
  WEB_TOUR_CAPTION: 'webtour_caption',
  WEB_TOUR_SCROLL: 'webtour_scroll',
  WEB_TOUR_TILE: 'webtour_tile',
  VIRTUAL_TOUR: 'virtual_tour',
};

export const trackClickTypes = {
  CLICK: 'product_click_event',
  VIEW: 'page_view_event',
  HUBS_VIEW: 'page_view_event',
  SCHOLARSHIPS: 'scholarship_shown',
};

export const trackYouVisit = {
  CLICK: 'youvisit_click_event',
  VIEW: 'youvisit_view_event',
};

export const trackingCategories = {
  TOP_RIGHT_NAV: 'Hubs Top Right Nav',
};

export const trackingLabels = {
  APPLY_ONLINE: 'Apply Online',
  COMMUNICATE: 'Communicate',
  COMMUNICATE_ADMISSIONS: 'Contact Admissions Office',
  COMMUNICATE_CONTACTS: 'Contact College Contact',
  COMMUNICATE_REQUEST_INFO: 'Request Information',
  LEARN_MORE: 'Learn More',
};

export function trackClick(hostContext, payload) {
  get(hostContext, 'trackClick', noop)(payload);
}

export function trackEventGa(hostContext, payload) {
  get(hostContext, 'trackEventGa', noop)(payload);
}

export function trackView(hostContext, payload) {
  get(hostContext, 'trackView', noop)(payload);
}

export function clickTrackingScholarships(hostContext, payload) {
  get(hostContext, 'clickTrackingScholarships', noop)(payload);
}

export function trackViewGa(hostContext, payload) {
  get(hostContext, 'trackViewGa', noop)(payload);
}

export default function withContext(Component) {
  return function contextComponent(props) {
    return (
      <HostContext.Consumer>
        {(context) => <Component {...props} hostContext={context} />}
      </HostContext.Consumer>
    );
  };
}
